export default __webpack_public_path__ + "static/media/Oil2Gas_08.6e38a50d.png";